import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

/**
 * The ⓘ that sits on a field's label.
 *
 * Explanations used to run as a paragraph under every control, which turned a
 * four-field panel into a wall of prose — the settings themselves got lost in
 * it. The help is the same; it just waits until it is asked for.
 *
 * Click, not hover: the panel is used on touch screens too, and a hover-only
 * tooltip is invisible there.
 */
const InfoTip = ({ text }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <span className={`gmbw-info${open ? " open" : ""}`} ref={ref}>
      <button
        type="button"
        aria-label="What this does"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5" />
          <path d="M12 7.6v.4" />
        </svg>
      </button>
      {open && <span className="gmbw-info-pop" role="tooltip">{text}</span>}
    </span>
  );
};

InfoTip.propTypes = { text: PropTypes.node.isRequired };

export default InfoTip;
